import { type AttributeSet } from "../attribute/AttributeSet";

export enum UserAttributeType {
  AGE = "age",
  ETHNICITY = "ethnicity",
  ROLE = "role",
  SEEKING = "seeking",
  RELATIONSHIP = "relationship",
  BODY = "body",
  LANGUAGES = "languages",
  BIRTHDAY = "birthday",
  WEIGHT = "weight",
  HEIGHT = "height",
  ABOUT_ME = "about_me",
  RESIDENCE = "residence",
  INTEREST = "interest",
}

export type UserAttributeSet = AttributeSet<UserAttributeType>;
